// extracted by mini-css-extract-plugin
export var deleteModal = "_e4-0";